import React, { useEffect } from 'react';
import { SkeletonText } from '../../../Components/Common/Skeleton';
import { DetailCard, Timeline } from '../../../Components/Common/Detail';
import { formatDateToddmmyyhhmm } from '../../../utils/dateformatter';

const ActivityTab = ({ activities = [], isLoading = false, onMount }) => {
  useEffect(() => {
    onMount?.();
  }, [onMount]);

  const items = activities.map((activity, index) => ({
    id: activity.id || index,
    title: activity.description || activity.action,
    meta: [
      activity.action,
      activity.activityDate
        ? formatDateToddmmyyhhmm(activity.activityDate)
        : null,
    ]
      .filter(Boolean)
      .join(' • '),
  }));

  return (
    <DetailCard
      title='Activity'
      icon='ri-history-line'
      hint='History of every awarding action on this procurement.'
      className='mb-0'
    >
      {isLoading ? (
        <SkeletonText lines={5} />
      ) : items.length ? (
        <Timeline items={items} />
      ) : (
        <div className='text-center py-4'>
          <i
            className='ri-history-line text-muted'
            style={{ fontSize: '3rem', opacity: 0.5 }}
          ></i>
          <p className='mt-2 mb-0 text-muted'>No activity recorded yet</p>
        </div>
      )}
    </DetailCard>
  );
};

export default ActivityTab;
